(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nutry-bm-vip-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function param(name) {
      try { return new URLSearchParams(window.location.search).get(name) || ''; } catch (e) { return ''; }
    }
    function referrerHost() {
      try { return document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : ''; } catch (e) { return ''; }
    }
    function track(landing) {
      try { if (window.fbq) window.fbq('track', 'CompleteRegistration', { content_name: 'Black Month VIP', content_category: landing, status: true }); } catch (e) {}
      try { if (window.gtag) window.gtag('event', 'generate_lead', { form_name: 'black_month_vip', landing: landing }); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'bm_vip_lead', landing: landing }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bm_vip_lead', { landing: landing }); } catch (e) {}
    }
    function postViaIframe(action, data) {
      return new Promise(function (resolve) {
        var name = 'bmvip-frame-' + Date.now();
        var frame = document.createElement('iframe');
        frame.name = name; frame.title = 'Envio da inscrição'; frame.hidden = true;
        document.body.appendChild(frame);
        var f = document.createElement('form');
        f.action = action; f.method = 'post'; f.target = name; f.hidden = true;
        data.forEach(function (value, key) {
          var i = document.createElement('input'); i.type = 'hidden'; i.name = key; i.value = value; f.appendChild(i);
        });
        document.body.appendChild(f);
        frame.addEventListener('load', function () { resolve(); });
        f.submit();
        setTimeout(resolve, 2500);
      });
    }
    function init(root) {
      if (root.hasAttribute('data-bmvip-ready')) return;
      root.setAttribute('data-bmvip-ready', '');
      var form = root.querySelector('[data-bmvip-form]');
      var success = root.querySelector('[data-bmvip-success]');
      var landing = root.getAttribute('data-landing') || '';
      var goal = param('objetivo').toLowerCase().replace(/[^a-z]/g, '');
      if (!form) return;
      if (goal) {
        var radio = root.querySelector('input[name="fields[objetivo]"][value="' + goal + '"]');
        if (radio) {
          radio.checked = true;
        } else if (!root.querySelector('input[name="fields[objetivo]"]')) {
          // Sem a escolha visível, guarda o objetivo que veio no link do anúncio.
          var hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = 'fields[objetivo]'; hidden.value = goal;
          form.appendChild(hidden);
        }
      }
      var source = root.querySelector('[data-bmvip-source]');
      var campaign = root.querySelector('[data-bmvip-campaign]');
      if (source) source.value = param('utm_source') || referrerHost() || 'direto';
      if (campaign) campaign.value = param('utm_campaign');
      var error = root.querySelector('[data-bmvip-error]');
      var button = root.querySelector('[data-bmvip-submit]');
      var email = form.querySelector('input[type="email"]');
      var consent = form.querySelector('[data-bmvip-consent]');
      function fail(msg) { error.textContent = msg; error.classList.add('is-visible'); }
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        error.classList.remove('is-visible');
        email.removeAttribute('aria-invalid');
        var value = (email.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
          email.setAttribute('aria-invalid', 'true'); email.focus();
          fail('Escreve um email válido, por exemplo nome@email.com.');
          return;
        }
        if (consent && !consent.checked) { fail('Para entrar na lista, aceita receber as ofertas por email.'); return; }
        button.disabled = true;
        var data = new FormData(form);
        var done = function () {
          try { localStorage.setItem('bmvip_joined', '1'); } catch (e) {}
          var thanks = root.getAttribute('data-thanks');
          if (thanks) {
            // A conversão é registada na página de obrigado, só para quem chega daqui.
            var reg = { t: Date.now(), id: 'bmvip-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8), landing: landing, email: value };
            var stored = false;
            try { sessionStorage.setItem('bmvip_reg', JSON.stringify(reg)); stored = true; } catch (e) {}
            if (!stored) track(landing);
            setTimeout(function () { window.location.assign(thanks); }, stored ? 0 : 400);
            return;
          }
          root.setAttribute('data-bmvip-email', value);
          form.hidden = true;
          if (success) { success.hidden = false; success.focus(); }
          track(landing);
        };
        fetch(form.action, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json().catch(function () { return { success: res.ok }; }); })
          .then(function (json) {
            if (json && json.success === false) {
              button.disabled = false;
              fail('Não foi possível concluir a inscrição. Confirma o email e tenta de novo.');
              return;
            }
            done();
          })
          .catch(function () { postViaIframe(form.action, data).then(done); });
      });
    }
    function bindAfter(root) {
      var action = (root.querySelector('[data-bmvip-form]') || {}).action;
      var ok = root.querySelector('[data-bmvip-after-ok]');
      root.querySelectorAll('[data-bmvip-goal]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          var email = root.getAttribute('data-bmvip-email');
          if (!email || !action) return;
          root.querySelectorAll('[data-bmvip-goal]').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
          var data = new FormData();
          data.append('fields[email]', email);
          data.append('fields[objetivo]', chip.getAttribute('data-bmvip-goal'));
          data.append('ml-submit', '1');
          data.append('anticsrf', 'true');
          fetch(action, { method: 'POST', body: data, headers: { Accept: 'application/json' } })
            .catch(function () { return postViaIframe(action, data); })
            .then(function () { if (ok) ok.hidden = false; });
        });
      });
    }
    function countdowns() {
      document.querySelectorAll('[data-bmvip-countdown]').forEach(function (el) {
        if (el.hasAttribute('data-bmvip-ready')) return;
        el.setAttribute('data-bmvip-ready', '');
        var target = Date.parse(el.getAttribute('data-bmvip-countdown'));
        if (isNaN(target)) return;
        var parts = {
          d: el.querySelector('[data-unit="d"]'), h: el.querySelector('[data-unit="h"]'),
          m: el.querySelector('[data-unit="m"]'), s: el.querySelector('[data-unit="s"]')
        };
        function pad(n) { return String(n).padStart(2, '0'); }
        function tick() {
          var t = Math.max(0, Math.floor((target - Date.now()) / 1000));
          if (parts.d) parts.d.textContent = Math.floor(t / 86400);
          if (parts.h) parts.h.textContent = pad(Math.floor((t % 86400) / 3600));
          if (parts.m) parts.m.textContent = pad(Math.floor((t % 3600) / 60));
          if (parts.s) parts.s.textContent = pad(t % 60);
          if (t === 0) { el.classList.add('is-done'); clearInterval(timer); }
        }
        var timer = setInterval(tick, 1000);
        tick();
      });
    }
    function boot() {
      document.querySelectorAll('[data-bmvip]').forEach(function (root) {
        var fresh = !root.hasAttribute('data-bmvip-ready');
        init(root);
        if (fresh) bindAfter(root);
      });
      countdowns();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
